export default "__VITE_ASSET__BsLAXaNV__"